(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-serving-film]').forEach(stage => {
      if (stage.dataset.ready) return;
      stage.dataset.ready = 'true';
      const video = stage.querySelector('video');
      const toggle = stage.querySelector('[data-serving-toggle]');
      if (!video || !toggle) return;
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const lifecycle = new AbortController();
      const options = { signal: lifecycle.signal };
      let requested = !preference.matches;
      let onScreen = false;
      const update = () => {
        toggle.textContent = video.paused ? 'Play video' : 'Pause video';
        toggle.setAttribute('aria-pressed', String(!video.paused));
      };
      const sync = () => {
        if (!requested || !onScreen || document.hidden) { video.pause(); update(); return; }
        const source = video.querySelector('source[data-src]');
        if (source && !source.getAttribute('src')) { source.src = source.dataset.src; video.load(); }
        video.play().then(update).catch(update);
      };
      toggle.hidden = false;
      toggle.addEventListener('click', () => { requested = video.paused; sync(); }, options);
      video.addEventListener('play', update, options);
      video.addEventListener('pause', update, options);
      preference.addEventListener('change', () => { requested = !preference.matches; sync(); }, options);
      document.addEventListener('visibilitychange', sync, options);
      const observer = new IntersectionObserver(entries => { onScreen = entries[0].isIntersecting; sync(); }, { threshold: .15 });
      observer.observe(stage);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(stage)) return;
        observer.disconnect(); video.pause(); lifecycle.abort();
      }, options);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
